import { styled } from '@material-ui/core/styles'

export const TagListRoot = styled('div')(({ theme }) => ({
  color: theme.palette.grey.dark,
  padding: theme.spacing(1, 0),
  margin: theme.spacing(4, 0),
  borderTop: `1px solid ${theme.palette.grey.light}`,
  borderBottom: `1px solid ${theme.palette.grey.light}`,
}))

export const Tag = styled('span')(({ theme }) => ({
  display: 'inline-block',
  marginRight: theme.spacing(1),
}))
